/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_GeburtsjahrInputs */

const en__field_geburtsjahr = /** @type {(inputs: _Field_GeburtsjahrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Year of Birth`)
};

const de__field_geburtsjahr = /** @type {(inputs: _Field_GeburtsjahrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geburtsjahr`)
};

/**
* | output |
* | --- |
* | "Year of Birth" |
*
* @param {_Field_GeburtsjahrInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_geburtsjahr = /** @type {((inputs?: _Field_GeburtsjahrInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_GeburtsjahrInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_geburtsjahr(inputs)
	return de__field_geburtsjahr(inputs)
});